import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SortDirection } from '../../../shared/enums/sort-direction.enum';
import { ConsolGridOrderBy } from '../../models/consol-grid-order-by.enum';
import { ConsolListFilterRequest } from '../../models/consol-list-filter-request.model';
import { Consol } from '../../models/consol.model';
import { CommonModule } from '@angular/common';
import { AbsoluteDatePipe } from '../../pipes/absolute-date.pipe';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-consolidation-list-table',
  templateUrl: './consolidation-list-table.component.html',
  imports: [CommonModule, AbsoluteDatePipe, RouterLink]
})
export class ConsolidationListTableComponent {
  @Input() public consolList: Consol[];
  @Input() public filter: ConsolListFilterRequest;
  @Input() public columns: any;
  @Input() public routerlinkPathFn?: (consol: any) => string;
  @Input() public isExtendedColumnsMode: boolean; 
  @Input() public trackerOnlyColumns: boolean; 
  @Input() public NoResultMessage: string;
  @Input() public isExtendedColumnsConsignee: boolean;

  @Output() public clearFilters = new EventEmitter();
  @Output() public update = new EventEmitter();

  public expandedRows: string[] = [];

  public sort(column: ConsolGridOrderBy): void {
    if (column === this.filter.SortColumn) {
      this.filter.SortDirection = (this.filter.SortDirection === SortDirection.Asc) ? SortDirection.Desc : SortDirection.Asc;
    } else {
      this.filter.SortColumn = column;
      this.filter.SortDirection = SortDirection.Asc;
    }

    this.update.emit();
  }

  public isSortedByColumn(column: ConsolGridOrderBy): boolean {
    return this.filter.SortColumn === column;
  }

  public isSortDirectionDesc(): boolean {
    return this.filter.SortDirection === SortDirection.Desc;
  }

  public expandRow(id: string): void {
    this.expandedRows.push(id);
  }

  public collapseRow(id: string): void {
    this.expandedRows = this.expandedRows.filter(rowId => rowId !== id);
  }

  public isRowExpandable(list: number[]): boolean {
    return list.length && list.length > 1;
  }

  public isRowExpanded(id: string): boolean {
    return this.expandedRows.indexOf(id) !== -1;
  }
}
